module.exports = __webpack_public_path__ + "assets/PerimeterBisector.fed2840713d7039c5a4b2e9046caa091.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/PerimeterBisector.gmt
// module id = 983
// module chunks = 0